import { __extends, __spreadArray, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import ImageWithActions from '../ImageWithActions/ImageWithActions.component.js';
import { Icon } from '../Icon/Icon.component.js';
import DropZone from '../DropZone/DropZone.component.js';
import { propTypes, defaultProps } from './ImageSelector.types.js';
import styles from './ImageSelector.module.scss.js';

var ImageSelector = /** @class */ (function (_super) {
    __extends(ImageSelector, _super);
    function ImageSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            errorMessage: '',
        };
        _this.inputRef = React__default.createRef();
        _this.handleUploadClick = function () {
            var _a;
            (_a = _this.inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
        };
        _this.handleChange = function (e) {
            var _a;
            _this.setState({
                errorMessage: '',
            });
            var onAddImages = _this.props.onAddImages;
            var files = (_a = e.target) === null || _a === void 0 ? void 0 : _a.files;
            if (files && files.length > 0) {
                onAddImages(files);
            }
        };
        _this.handleDrop = function (files) {
            _this.setState({
                errorMessage: '',
            });
            var dt = new DataTransfer();
            var _a = _this.props, onAddImages = _a.onAddImages, onFilesRejected = _a.onFilesRejected, accepted = _a.accepted;
            var _b = Array.from(files).reduce(function (acc, file) {
                var isAcceptedFormat = accepted === 'image/'
                    ? file.type.includes('image/')
                    : file.type && (accepted === null || accepted === void 0 ? void 0 : accepted.includes(file.type));
                if (isAcceptedFormat) {
                    dt.items.add(file);
                    acc.acceptedFiles = dt.files;
                }
                else {
                    acc.rejectedFiles.push(file);
                }
                return acc;
            }, { rejectedFiles: [], acceptedFiles: dt.files }), rejectedFiles = _b.rejectedFiles, acceptedFiles = _b.acceptedFiles;
            if (rejectedFiles.length) {
                if (onFilesRejected) {
                    onFilesRejected(rejectedFiles);
                }
                else {
                    var rejectedFilesName = rejectedFiles
                        .map(function (file) { return file.name; })
                        .join(',');
                    _this.setState({
                        errorMessage: rejectedFilesName + " was rejected, because of wrong format",
                    });
                }
            }
            if (acceptedFiles.length)
                onAddImages(acceptedFiles);
        };
        _this.renderImagePicker = function () {
            var _a = _this.props, images = _a.images, layout = _a.layout, accepted = _a.accepted;
            var pickerText = _this.props.pickerText;
            var classModifier = '';
            if (layout === 'grid') {
                if (images.length > 0) {
                    classModifier = styles.ImagePicker___compact;
                    pickerText = '';
                }
            }
            else {
                classModifier = styles.ImagePicker___list;
            }
            return (React__default.createElement("div", { className: clsx(styles.ImagePicker, classModifier), onClick: _this.handleUploadClick },
                React__default.createElement("input", { ref: _this.inputRef, type: "file", "data-testid": "file-input", multiple: true, accept: accepted, className: styles.ImagePicker_input, onChange: _this.handleChange }),
                React__default.createElement(Icon, { className: styles.ImagePicker_icon, name: "CloudUploadIcon", size: 30, alt: "click to select images" }),
                React__default.createElement("p", { className: styles.ImagePicker_label }, pickerText)));
        };
        _this.renderImageAtIndex = function (index) {
            var _a;
            var _b = _this.props, images = _b.images, onCropImage = _b.onCropImage, onRemoveImage = _b.onRemoveImage, onCoverImage = _b.onCoverImage, layout = _b.layout;
            var item = images[index];
            var classModifier = '';
            if (layout === 'grid') {
                /**
                 * Adds half modifier to image depending on images length and isCover prop.
                 * Custom logic was needed to fit grid layout design specs
                 */
                if (item.isCover && images.length >= 4) {
                    classModifier = styles.ImageSelector_image___half;
                }
                else if (!item.isCover && images.length > 2) {
                    classModifier = styles.ImageSelector_image___half;
                }
            }
            else {
                classModifier = styles.ImageSelector_image___list;
            }
            var actionsWOCover = [
                {
                    title: 'Crop',
                    iconName: 'CropIcon',
                    iconAlt: 'crop',
                    onClick: function () { return onCropImage(index); },
                    className: styles.ActionButton,
                },
                {
                    title: 'Remove',
                    iconName: 'DeleteIcon',
                    iconAlt: 'delete',
                    onClick: function () { return onRemoveImage(index); },
                    className: styles.ActionButton,
                },
            ];
            var actions = __spreadArray(__spreadArray([], actionsWOCover, true), [
                {
                    title: 'Cover',
                    iconName: 'PinIcon',
                    iconAlt: 'set as cover',
                    onClick: function () { return onCoverImage(index); },
                    className: styles.ActionButton,
                },
            ], false);
            var customActions = Array.isArray(item.customActions) &&
                ((_a = item.customActions) === null || _a === void 0 ? void 0 : _a.map(function (customAction) { return (__assign(__assign({}, customAction), { onClick: function () { return customAction.onClick(index); }, className: clsx(styles.ActionButton, customAction.className) })); }));
            return (React__default.createElement(ImageWithActions, { key: item.imgUrl, label: item.isCover ? 'COVER' : '', className: "\n                    " + styles.ImageSelector_image + "\n                    " + classModifier + "\n                ", actions: customActions || (item.isCover ? actionsWOCover : actions), imgUrl: item.imgUrl, imgAlt: "name" }));
        };
        _this.renderMoreImagesOverlay = function () {
            var _a = _this.props, images = _a.images, onShowMoreImages = _a.onShowMoreImages;
            return (React__default.createElement("div", { className: styles.Overlay, style: { backgroundImage: "url(\"" + images[4].imgUrl + "\")" }, onClick: onShowMoreImages },
                React__default.createElement("h3", { className: styles.Overlay_text },
                    "+ ",
                    images.length - 4)));
        };
        _this.renderGridLayout = function () {
            var _a = _this.props, images = _a.images, className = _a.className;
            return (React__default.createElement("div", { className: clsx(styles.ImageSelector, styles.ImageSelector___grid, className) },
                React__default.createElement(DropZone, { onDrop: _this.handleDrop },
                    React__default.createElement("div", { className: clsx(styles.Row, styles.Row___fullHeight) },
                        images.length > 0 && (React__default.createElement("div", { className: styles.Row },
                            React__default.createElement("div", { className: styles.Column },
                                _this.renderImageAtIndex(0),
                                images.length > 3 &&
                                    _this.renderImageAtIndex(2)),
                            images.length > 1 && (React__default.createElement("div", { className: styles.Column },
                                _this.renderImageAtIndex(1),
                                images.length > 4
                                    ? _this.renderMoreImagesOverlay()
                                    : images.length > 2 &&
                                        _this.renderImageAtIndex(images.length - 1))))),
                        _this.renderImagePicker())),
                _this.state.errorMessage && (React__default.createElement("div", { className: styles.ImageSelector___errorMessage }, _this.state.errorMessage))));
        };
        _this.renderListLayout = function () {
            var _a = _this.props, images = _a.images, className = _a.className;
            return (React__default.createElement("div", { className: clsx(styles.ImageSelector, styles.ImageSelector___list, className) },
                images.map(function (image, i) { return _this.renderImageAtIndex(i); }),
                React__default.createElement(DropZone, { onDrop: _this.handleDrop, className: clsx(styles.ImageSelector_image, styles.ImageSelector_image___list) }, _this.renderImagePicker()),
                _this.state.errorMessage && (React__default.createElement("div", { className: styles.ImageSelector___errorMessage }, _this.state.errorMessage))));
        };
        return _this;
    }
    ImageSelector.prototype.render = function () {
        var layout = this.props.layout;
        return layout === 'grid'
            ? this.renderGridLayout()
            : this.renderListLayout();
    };
    ImageSelector.displayName = 'ImageSelector';
    ImageSelector.propTypes = propTypes;
    ImageSelector.defaultProps = __assign({}, defaultProps);
    return ImageSelector;
}(React__default.Component));

export { ImageSelector as default };
